<!--用户中心-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="course-container">
                <div class="left-menu-container">
                    <user-center-menu :item-num="this.activeItem"
                                 @change-item="changeItem"/>
                </div>
                <!-- 个人资料 -->
                <div v-if="activeItem==='1'"  class="right-content-container">
                    <user-info />
                </div>
                <!-- 消息中心 -->
                <div v-if="activeItem==='2'"  class="right-content-container">
                    <msg-center />
                </div>
                <!-- 任务中心 -->
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <task-center />
                </div>
                <!-- 收藏中心 -->
                <div v-if="activeItem==='4'"  class="right-content-container">
                    <collection-center />
                </div>
                <!-- 我的关注 -->
                <div v-if="activeItem==='5'"  class="right-content-container">
                    <follow-center />
                </div>
                <!-- 教师档案 -->
                <div v-if="activeItem==='6'"  class="right-content-container">
                    <teacher-archives/>
                </div>
                <!-- 成长中心 -->
                <div v-if="activeItem==='7'"  class="right-content-container">
                    <develop-center />
                </div>
                <!-- 课程收藏 -->
                <div v-if="activeItem==='8'"  class="right-content-container">
                    <collection-center />
                </div>
                <!-- 我的关注 -->
                <div v-if="activeItem==='9'"  class="right-content-container">
                    <follow-center />
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { serviceWebUrl } from "@/utils/global"
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import userCenterMenu from "@/components/userCenter/userCenterMenu.vue";
import userInfo from "@/components/userCenter/userInfo.vue";
import msgCenter from "@/components/userCenter/msgCenter.vue";
import taskCenter from "@/components/userCenter/taskCenter.vue";
import collectionCenter from "@/components/userCenter/collectCenter.vue";
import followCenter from "@/components/userCenter/followCenter.vue";
import teacherArchives from "@/components/userCenter/teacherArchives.vue";
import developCenter from "@/components/userCenter/developCenter.vue";
import courseCollection from "@/components/userCenter/courseCollection.vue";
export default {
    components: {
        userCenterMenu,
        dataEmpty,
        homeHead,
        userInfo,
        msgCenter,
        taskCenter,
        collectionCenter,
        followCenter,
        teacherArchives,
        developCenter,
        courseCollection
    },
    name: "homeUserCenter",
    data() {
        return {
            serviceWebUrl,
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeUserCenter",
            activeItem:"1",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
        if (this.$store.state.params.jumpParams.activeItem){
            this.activeItem = this.$store.state.params.jumpParams.activeItem;
        }

    },
    methods: {
        changeItem(item){
            // if (item==='6'){
            //     window.open(serviceWebUrl+'/fileFill', '_blank')
            //     return;
            // }
            this.activeItem = item;
            this.activeMode = this.pageMode;
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #ff7f2e;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>